import type { GetStaticProps } from 'next';
import { fetchBlogPosts } from '../utils/api/fetchStrapiData';
import Team from '../views/team';

export const getStaticProps: GetStaticProps = async () => {
  const data = await fetchBlogPosts();

  return {
    props: { blogPosts: data },
  };
};

export default Team;
